import script from "./BrandSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandSelect.vue?vue&type=script&setup=true&lang=js"

import "./BrandSelect.vue?vue&type=style&index=0&id=38c07956&scoped=true&lang=css"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38c07956"]])

export default __exports__